import CountryPickerLite from './CountryPickerLite';

export default CountryPickerLite;
